// import Vue from 'vue';
import App from './App.vue';
// //import librerias from './librerias.js';

// Vue.config.productionTip = false

// new Vue({
//   render: h => h(App),
// }).$mount('#app')

import { createApp } from 'vue';

// Then, create your app instance:
const app = createApp(App);
app.mount('#app');